import { useState } from 'react'
import * as React from 'react'

import { ISchool } from '../../../interfaces/school.interface'
import dynamic from 'next/dynamic'
import { useSchoolExternalIntegrations } from '../useSchoolExternalIntegrations'

const TawkIOIntegration = dynamic(
  () => import('./TawkIOIntegration/TawkIOIntegration'),
  {
    ssr: false,
    loading: () => <span />,
  },
)

export default function LiveChatExternalIntegrationDomComponent(props: {
  schoolDetails: ISchool
  currentUrl: string
}) {
  const [schoolDetails] = useState(props.schoolDetails)
  const externalIntegrationHooks = useSchoolExternalIntegrations()

  return (
    <>
      {schoolDetails?.integrationScripts
        ?.filter(i => i?.integrationDetails?.scope === 'livechat')
        .map(sc => {
          return (
            <React.Fragment key={sc.integrationDetails?.id}>
              {sc.integrationDetails?.id === 'tawkIO' &&
                externalIntegrationHooks.integrationPathIsValid(
                  sc?.integrationDetails?.enabledPaths,
                  props.currentUrl,
                ) && (
                  <TawkIOIntegration
                    propertyId={
                      sc?.schoolIntegrationDetails?.integrationValues
                        ?.propertyId
                    }
                    tawkId={
                      sc?.schoolIntegrationDetails?.integrationValues?.tawkId
                    }
                    integrationDetails={sc?.integrationDetails}
                  />
                )}
            </React.Fragment>
          )
        })}
    </>
  )
}
